import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Container,
  Paper,
  Link,
  Grid
} from '@mui/material';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { useSupabase } from '../contexts/SupabaseContext';
import GoogleIcon from '@mui/icons-material/Google';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const Register = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    name: ''
  });
  const [error, setError] = useState('');
  const { signUp, signInWithGoogle, user } = useSupabase();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const error = await signUp(formData.email, formData.password); // Pass email and password directly
      if (error) {
        // Check for existing email error (Supabase returns code '23505' or message containing 'already registered')
        if (
          error.message?.toLowerCase().includes('already registered') ||
          error.message?.toLowerCase().includes('already exists') ||
          error.code === '23505'
        ) {
          setError('This email is already registered. Please use a different email or sign in.');
        } else {
          setError(error.message);
        }
        return;
      }
      // Redirect to login after successful registration
      navigate('/login', {
        state: { message: 'Registration successful! Please check your email to verify your account.' }
      });
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Typography variant="h5" component="h1" sx={{ marginBottom: '2px', fontWeight: 'bold', color: 'primary.main', textAlign: 'center', fontSize: '2rem' }}>Mickles</Typography>
          <Typography variant="body1" sx={{ textAlign: 'center', color: 'primary.main', mb: 2, fontStyle: 'italic' }}>
            Many A Mickle Makes A Muckle
          </Typography>
          <Typography component="h1" variant="h5" align="center" gutterBottom>
            Sign up
          </Typography>
          <Typography color="warning" align="center" gutterBottom sx={{ mt: 3, mb: 3, fontWeight: 500 }}>
            You can sign up with your Google account.
          </Typography>
          <Button
            fullWidth
            variant="outlined"
            startIcon={<GoogleIcon />}
            sx={{ mb: 2 }}
            onClick={signInWithGoogle}
          >
            Sign up with Google
          </Button>
          <Box sx={{ textAlign: 'center' }}>
            <Link component={RouterLink} to="/login" variant="body2">
              Already have an account? Sign in
            </Link>
          </Box>
          <Box sx={{ textAlign: 'center' }}>
            <Link component={RouterLink} to="/forgot-password" variant="body2">
              Forgot password?
            </Link>
          </Box>
        </Paper>
      </Box>
      <Box
        sx={{
          mt: 3,
          mb: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1.5,
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 400, color: 'text.secondary' }}>
          Contact us:
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <EmailIcon sx={{ color: 'primary.main', fontSize: 20 }} />
          <Link
            href="mailto:hello@mickles.in"
            sx={{
              textDecoration: 'none',
              color: 'primary.main',
              fontWeight: 400,
              '&:hover': {
                textDecoration: 'underline',
                color: 'primary.dark',
              },
            }}
          >
            hello@mickles.in
          </Link>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WhatsAppIcon sx={{ color: 'primary.main', fontSize: 20 }} />
          <Link
            href="https://wa.me/919739900966"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              textDecoration: 'none',
              color: 'primary.main',
              fontWeight: 400,
              '&:hover': {
                textDecoration: 'underline',
                color: 'primary.dark',
              },
            }}
          >
            +91 9739 900 966
          </Link>
        </Box>
      </Box>
    </Container>

  );
};

export default Register; 